import { SupplierModelType } from '@teinor/erp/types/company/supplier'
import { SupplierContactPersonModelType } from '@teinor/erp/types/company/supplier/supplierContactPerson'
import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import ModalCESupplierContactPerson from './ModalCESupplierContactPerson'
import TwinTable from '../../../../../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { EditRow, DeleteRow } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import ModalDeleteSupplierContactPerson from './ModalDeleteSupplierContactPerson'

interface SupplierContactPersonsProps extends ComponentWithPermissions {
    basicData: SupplierModelType | null
}

const SupplierContactPersons: React.FC<SupplierContactPersonsProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('contactsPerson', 'Personas de contacto'),
        newText: t('addContactPerson', 'Nueva persona de contacto'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableSupplierContactPersons} CreateModalComponent={ModalCESupplierContactPerson} EditModalComponent={ModalCESupplierContactPerson} DeleteModalComponent={ModalDeleteSupplierContactPerson} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{ SupplierId: basicData?.id }} />
    )
}
interface TableSupplierContactPersonsProps extends TableComponentBaseScreenInnerProps { }

const TableSupplierContactPersons: React.FC<TableSupplierContactPersonsProps> = ({ setTableInstance, userPermissions, extraWhereParams, setOpened }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<SupplierContactPersonModelType> = [
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 130,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'position',
            dataKey: 'position',
            label: t('position', 'Cargo'),
            sortable: true,
        },
        {
            id: 'mobile',
            dataKey: 'mobile',
            label: t('mobile', 'Móvil'),
        },
        {
            id: 'phone',
            dataKey: 'phone',
            label: t('phone', 'Teléfono'),
        },
        {
            id: 'email',
            dataKey: 'email',
            label: t('email', 'Email'),
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable columns={columns} name='supplierContactPersons' getDataFrom='/api/app/supplier/supplierContactPerson/getAllSupplierContactPersons'

            onRowClick={(_id, rowData) => setOpened({
                type: 'edit',
                allRowData: rowData
            })}
            setTableInstance={setTableInstance} extraWhereParams={{ active: true, ...extraWhereParams }}
        />
    )
}

export default SupplierContactPersons